<script setup>
import { onMounted, defineProps, ref, defineEmits, computed, inject, reactive } from 'vue';
import ProductsBlock from "@/components/ProductsBlock";
import { KinescopePlayer } from '@kinescope/vue-kinescope-player'

const props = defineProps({
  pageType: {
    type: String,
    default: '',
  },
  data: {
    type: Object,
    default: () => {}
  },
  step: {
    type: Number,
    default: 1
  }
})

const emit = defineEmits(['buttonClick']);

const selectedVideo = ref(0);

const showVideo = computed(() => props.step === 1);

const sendEventAlt = inject('sendEventAlt');

const sent = reactive(new Set());
const allowTimeWatching = ref(false);

const onTimeUpdate = ({ percent }) => {
  if (!allowTimeWatching.value) return;

  [30, 60, 90].forEach(p => {
    if (percent >= p && !sent.has(p)) {
      sendEventAlt('video_percent',
          { name: 'stage', value: props.pageType },
          { name: 'lesson_number', value: `Урок${selectedVideo.value + 1}` },
          { name: 'percent', value: `percent${p}` }
      );
      sent.add(p);
    }
  });
};

const clearTimeFlags = () => sent.clear();

const playerRef = ref(null);
const rewindToStart = () => {
  clearTimeFlags();
  playerRef.value?.player?.seekTo(0);
}

onMounted(() => {
})

</script>
<template>
  <div>
    <div class="lessons">
      <h2 class="lessons__title" v-html="data?.title"></h2>
      <kinescope-player
          v-if="showVideo"
          :video-id="data?.videos[selectedVideo]?.id"
          @play="sendEventAlt('video_play', { name: 'stage', value: pageType }, { name: 'lesson_number', value: `Урок${selectedVideo + 1}` }); allowTimeWatching = true;"
          @time-update="onTimeUpdate"
          @ended="rewindToStart();"
          @ready="rewindToStart();"
          class="lessons__player"
          ref="playerRef"
      ></kinescope-player>
      <div class="lessons__nav">
        <div
            v-for="(item, index) in data?.videos"
            :class="['lessons__nav-item', {'lessons__nav-item_selected': index === selectedVideo}]"
            :key="item.id"
            @click="selectedVideo = index; sendEventAlt('lesson_click', { name: 'stage', value: pageType }, { name: 'lesson_number', value: `Урок${selectedVideo + 1}` }); clearTimeFlags();"
        >
          <img :src="require(`@/assets/img/${pageType}/poster${index + 1}-${pageType}.png`)" alt=""/>
          <h3 v-html="item.title"></h3>
        </div>
      </div>
    </div>
    <div class="products">
      <img :src="require(`@/assets/img/${pageType}/girl-${pageType}.png`)" alt="" class="products__girl"/>
      <img :src="require(`@/assets/img/${pageType}/boy-${pageType}.png`)" alt="" class="products__boy"/>
      <div class="products__top">
        <h2 class="products__title" v-html="data?.gameText"></h2>
        <a
            href="#"
            class="products__button"
            @click.prevent="emit('buttonClick'); sendEventAlt('lesson_create_button_click', { name: 'stage', value: pageType })"
        >{{ data?.buttonText }}</a>
      </div>
      <ProductsBlock/>
    </div>
  </div>
</template>